/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAffiliateDto
 */
export interface CreateAffiliateDto {
    /**
     * 
     * @type {string}
     * @memberof CreateAffiliateDto
     */
    code: string;
}

export function CreateAffiliateDtoFromJSON(json: any): CreateAffiliateDto {
    return CreateAffiliateDtoFromJSONTyped(json, false);
}

export function CreateAffiliateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAffiliateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

export function CreateAffiliateDtoToJSON(value?: CreateAffiliateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
    };
}

